<template>
  <div class="container">
    <div class="columns">
      <div class="column is-3">
          <b-tabs>
            <b-tab-item label="モデル">
              <aside class="menu is-hidden-mobile">

                <p class="menu-label">SX-Score標準</p>
                <p>
                  <b-loading :is-full-page="false" :active="true" style="position: relative"></b-loading>
                </p>
                <ul v-for="group in modelsMeta.groups" class="menu-list">
                  <li>
                    <a @click="group.toggle = !group.toggle">
                      {{ group.display_name }}<span class="icon"><i class="fas fa-angle-down"
                                                                    aria-hidden="true"></i></span>
                    </a>
                    <ul v-show="!group.toggle">
                      <li v-for="model_id in group.models">
                        <a @click="selectModel(model_id, group.id)" :class="form.model.includes(model_id) ? 'is-active' : ''">
                          {{modelsMeta.models[model_id].display_name }}
                        </a>
                      </li>
                    </ul>
                  </li>
                </ul>

              </aside>
            </b-tab-item>

            <b-tab-item label="バンドル">
              <aside class="menu is-hidden-mobile">

                <p class="menu-label">
                  <button class="button is-small is-primary"
                          @click="bundle.isModalActive = !bundle.isModalActive">バンドル作成
                  </button>
                  <b-tooltip
                    label="適用するデータの項目が同じモデルを複数選択し、バンドルとして保存します。作成したバンドルを使って一括でスコアの算出が可能です。"
                    position="is-right" multilined>
                    <span class="icon is-small is-pointer"><i class="fas fa-question-circle"></i></span>
                  </b-tooltip>
                </p>

                <ul class="menu-list">
                  <li v-for="bundle_id in modelsMeta.bundle.models" :key="bundle_id">
                    <a @click="selectModel(bundle_id, 'bundle')"
                       :class="form.model.includes(bundle_id) ? 'is-active' : ''">{{
                      modelsMeta.models[bundle_id].display_name }}</a>
                  </li>
                </ul>

              </aside>
            </b-tab-item>

        </b-tabs>

      </div>

      <div class="column is-9">
        <section class="hero is-small">
          <div class="hero-body">
            <template v-if="form.model">

              <p class="title is-4 is-spaced">
                {{ display.model }}
                <a v-if="bundle.selected" class="button is-text has-text-danger delete-button" @click="deleteBundle">削除</a>
              </p>
              <p class="subtitle is-6">{{ display.description }}</p>


              <b-tabs v-model="form.scoringType" type="is-toggle" expanded>

                <b-tab-item label="ファイルアップロード(csv, xlsx)">
                  <b-field grouped position="is-left">
                    <div class="control">
                      <p style="font-size: 0.8rem;">※ファイルの拡張子がxlsxの場合、csvへの変換のため処理時間が少し長くなります</p>
                      <a class="button is-text"
                         href="https://s3-ap-northeast-1.amazonaws.com/dev.sx-score.models/sample/sx_score_data_sample_1.csv"
                         style="font-size: 0.8rem;">
                        <span class="icon">
                          <i class="fas fa-file-download"></i>
                        </span>
                        <span>サンプルCSVをダウンロード</span>
                      </a>
                    </div>
                  </b-field>
                  <file-upload-area v-model="form.dataFile"
                                    :is-uploading="upload.isUploading"
                                    :is-disabled="upload.isDisabled"/>
                </b-tab-item>

                <b-tab-item label="データ入力" v-model="form.scoringType">
                  <b-tabs>
                    <b-tab-item label="フォーム">

                      <div class="box">

                        <button class="button field" @click="activateInputModal"
                                :disabled="dataInput.table.rows.length >= 10">
                            <span class="icon is-small">
                              <i class="fas fa-plus"></i>
                            </span>
                          <span>スコアリング対象に追加</span>
                        </button>

                        <b-message v-if="dataInput.table.rows.length === 0" type="is-warning">
                          「スコアリング対象に追加」でこちらにデータを追加してください（10件まで）
                        </b-message>

                        <b-table v-else :data="dataInput.table.rows" ref="table">

                          <template slot-scope="props">
                            <b-table-column v-for="column in dataInput.table.columns"
                                            :field="column.field"
                                            :label="column.label"
                                            :centered="true">
                              {{ labeling(column.field, props.row[column.field]) }}
                            </b-table-column>

                            <b-table-column>
                              <b-tooltip label="編集" type="is-light">
                                <span class="icon has-text-dark" @click="editInputs(props.index)">
                                  <i class="fas fa-edit"></i>
                                </span>
                              </b-tooltip>
                              <b-tooltip label="削除" type="is-danger">
                                <span class="icon has-text-danger" @click="deleteInputs(props.index)">
                                  <i class="fas fa-times-circle"></i>
                                </span>
                              </b-tooltip>
                            </b-table-column>
                          </template>

                        </b-table>

                      </div>

                    </b-tab-item>

                    <b-tab-item label="JSON">
                      <textarea v-model="form.dataJSON" class="textarea"></textarea>
                    </b-tab-item>
                  </b-tabs>
                </b-tab-item>

              </b-tabs>

              <b-field grouped position="is-right">
                <div class="control">
                  <button class="button is-text" @click="reset">リセット</button>
                </div>
                <div class="control">
                  <button class="button is-primary" @click="scoring">スコアリング</button>
                </div>
              </b-field>
            </template>
            <template v-else>
              <p class="subtitle is-4">モデルまたはバンドルを選択してください</p>
            </template>

          </div>
        </section>
      </div>
    </div>
    <score-modal :isModalActive="result.isModalActive"
                 :raw="result.raw"
                 :model="result.model"
                 :scores="result.scores"
                 :columns="result.columns"
                 :is-result="true"/>


    <bundling-modal :isModalActive="bundle.isModalActive" @close="bundle.isModalActive = false"/>

    <b-modal :active.sync="dataInput.isModalActive"
             scroll="keep"
             :canCancel="false"
             @close="cancelEdit">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">スコアリング対象データ入力</p>
        </header>
        <section class="modal-card-body">

          <b-field horizontal label="ID">

            <b-input v-model="dataInput.value.id"></b-input>

          </b-field>

          <b-field v-for="input in dataInput.inputs" horizontal :label="input.label">

            <b-input v-if="input.type === 'number'"
                     v-model="dataInput.value[input.name]"
                     :placeholder="input.placeholder"
                     type="number"
                     :min="input.min"
                     :max="input.max">
            </b-input>

            <b-select v-else-if="input.type === 'select'"
                      :placeholder="input.label"
                      v-model="dataInput.value[input.name]">
              <option v-for="item in input.items" :value="item.value">{{ item.label }}</option>
            </b-select>

            <b-input v-else-if="input.type === 'text'"
                     v-model="dataInput.value[input.name]"
                     :placeholder="input.placeholder"
                     type="text"
                     :minlength="input.max_len"
                     :maxlength="input.min_len">
            </b-input>
          </b-field>

        </section>
        <footer class="modal-card-foot">
          <button class="button is-text" @click="cancelEdit">キャンセル</button>
          <button class="button is-primary" @click="addInputItems">追加</button>
        </footer>
      </div>
    </b-modal>

    <b-loading :is-full-page="loading.isFullPage" :active.sync="loading.isActive"
               :can-cancel="false"></b-loading>

  </div>
</template>

<script>
import Selector from '../components/inputs/Selector'
import RadioButton from '../components/inputs/RadioButton'
import FileUploadArea from '../components/inputs/FileUploadArea'
import Loading from '../components/Loading'
import ScoreModal from '../components/ScoreModal'
import BundlingModal from '../components/BundlingModal'

import {ScoringValidator} from '../modules/validation'
import {scoringRequest, scoringTransactionRequest, uploadToS3Request, scoringSignatureRequest} from '../modules/request/scoring'
import {modelsRequest, deleteBundleRequest} from '../modules/request/models'
import BField from 'buefy/src/components/field/Field'
import BTableColumn from 'buefy/src/components/table/TableColumn'

export default {
  name: 'Scoring',
  components: {
    BTableColumn,
    BField,
    'model-selector': Selector,
    'scoring-type-radio': RadioButton,
    'file-upload-area': FileUploadArea,
    'score-modal': ScoreModal,
    'bundling-modal': BundlingModal,
    'loading': Loading
  },
  async mounted () {
    await this.getModels()
  },
  data () {
    return {
      bundle: {
        isModalActive: false,
        selected: ''
      },
      display: {
        model: '',
        description: '',
        modelGroups: {}
      },
      loading: {
        isFullPage: true,
        isActive: false
      },
      upload: {
        file: File,
        isUploading: false,
        isDisabled: false
      },
      form: {
        scoringType: 0,
        model: '',
        dataFile: null,
        dataJSON: ''
      },
      dataInput: {
        valueProto: {},
        value: {},
        table: {
          columns: [],
          rowsDisplay: [],
          rows: []
        },
        inputs: [],
        editIndex: -1,
        isModalActive: false
      },
      modelsMeta: {
        groups: [],
        bundle: {},
        models: [],
        inputs: {}
      },
      result: {
        raw: {},
        model: '',
        scores: [],
        columns: [],
        isModalActive: false
      }
    }
  },
  methods: {
    async getModels () {
      this.loading.isActive = true

      let modelsMeta = await modelsRequest(this)

      for (let i in modelsMeta.groups) {
        const group = modelsMeta.groups[i]
        if (group.id === 'bundle') {
          this.modelsMeta.bundle = group
          modelsMeta.groups.splice(i, 1)
        }
        group['toggle'] = true

      }

      this.modelsMeta.models = modelsMeta.models
      this.modelsMeta.groups = modelsMeta.groups
      this.modelsMeta.inputs = modelsMeta.inputs
    },
    selectModel (modelID, groupID) {

      let meta = this.modelsMeta.models[modelID]

      this.form.model = modelID
      this.display.model = meta.display_name
      this.display.description = meta.description

      this.bundle.selected = groupID === 'bundle' ? modelID : ''

      let value = {id: null}
      let columns = [{field: 'id', label: 'ID'}]
      let inputs = []

      for (let i in meta.inputs) {
        let key = meta.inputs[i]
        let input = this.modelsMeta.inputs[key]

        value[input.name] = null
        columns.push({field: input.name, label: input.label})
        inputs.push(input)
      }

      this.dataInput.valueProto = Object.assign({}, value)
      this.dataInput.value = value
      this.dataInput.table.columns = columns
      this.dataInput.inputs = inputs
    },
    async scoring () {
      let scoringForm = this.form

      if (scoringForm.scoringType === 1) {
        let dataRows = this.dataInput.table.rows

        if (!scoringForm.dataJSON && dataRows.length) {
          scoringForm.dataJSON = JSON.stringify({data: dataRows})
        }
      }

      let validated = ScoringValidator.validate(scoringForm)

      if (!validated.result) {
        this.$dialog.alert(validated.warning)
        return false
      }

      const scoringType = scoringForm.scoringType
      const validatedParam = validated.param

      this.loading.isActive = true
      let response = {}
      const $parent = this

      if (scoringType === 0) {
        let signatureData = await scoringSignatureRequest(validatedParam, this)
        const transactionId = signatureData.transaction_id
        await uploadToS3Request(signatureData.url, scoringForm.dataFile, this)
        response = await scoringTransactionRequest(transactionId, this)
        this.loading.isActive = false

        this.$dialog.alert({
          title: 'オフラインスコアリングを開始しました',
          message: 'スコアリング完了後、スコア一覧より結果が確認出来ます。',
          type: 'is-info',
          hasIcon: true,
          onConfirm () {
            $parent.$router.push({name: 'results'})
          }
        })
      } else {
        response = await scoringRequest(validatedParam, this)
        this.loading.isActive = false


        let data = response.data
        let result = this.result

        result.raw = data
        result.model = data.model_id
        result.scores = data.scores

        let columns = []

        for (let i in data.columns) {
          let columnName = data.columns[i]
          columns.push({field: columnName, label: columnName})
        }

        result.columns = columns
        result.isModalActive = true

        scoringForm.dataJSON = ''
      }
    },
    reset () {
      let initialData = this.$options.data()
      this.form = initialData.form
      this.upload = initialData.upload
      this.dataInput = initialData.dataInput
    },
    activateInputModal () {
      this.dataInput.value.id = this.dataInput.table.rows.length + 1
      this.dataInput.isModalActive = true
    },
    addInputItems () {

      let currentValue = Object.assign({}, this.dataInput.value)

      for (let key in currentValue) {
        if (currentValue[key] == null) {
          this.$toast.open({
            message: '未入力の項目があります',
            type: 'is-warning'
          })
          return false
        }
      }

      let inputRows = this.dataInput.table.rows

      if (inputRows.length >= 10) {
        this.$toast.open({
          message: 'インプットの上限は10件までです',
          type: 'is-warning'
        })
        return false
      }

      let editIndex = this.dataInput.editIndex

      if (editIndex > -1) {
        inputRows[editIndex] = currentValue
        this.dataInput.editIndex = -1
      } else {
        inputRows.push(currentValue)
      }

      this.dataInput.value = Object.assign({}, this.dataInput.valueProto)
      this.dataInput.isModalActive = false
    },
    labeling (field, value) {
      if (field === 'sex') {
        return value === 0 ? '男' : '女'
      }
      return value
    },
    editInputs (index) {
      this.dataInput.value = this.dataInput.table.rows[index]
      this.dataInput.editIndex = index
      this.dataInput.isModalActive = true
    },
    cancelEdit () {
      this.dataInput.value = Object.assign({}, this.dataInput.valueProto)
      this.dataInput.editIndex = -1
      this.dataInput.isModalActive = false
    },
    deleteInputs (index) {
      this.dataInput.table.rows.splice(index, 1)
    },
    deleteBundle () {
      let bundleID = this.bundle.selected
      let $parent = this

      this.$dialog.confirm({
        title: 'バンドル削除',
        message: `バンドル名：<b>${this.modelsMeta.models[bundleID].display_name}</b>
              <br><br>こちらのバンドルを削除します。よろしいですか？`,
        cancelText: 'キャンセル',
        confirmText: '削除',
        type: 'is-danger',
        hasIcon: true,
        async onConfirm () {
          $parent.loading.isActive = true
          let response = await deleteBundleRequest($parent, bundleID)
          $parent.$toast.open('削除が完了しました')
          $parent.loading.isActive = false
          $parent.getModels()
          $parent.reset()
        }
      })
    }
  }
}
</script>

<style scoped>

  textarea {
    height: 25rem;
  }

  .buttons {
    margin-top: 1rem;
  }

  .hero {
    background: white;
    height: 100%;
  }

  .subtitle {
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: #8F99A3;
  }

  .menu-label {
    color: #8F99A3;
    letter-spacing: 1.3px;
    font-weight: 700;
  }

  .menu-list a {
    color: #0F1D38;
    font-size: 0.9rem;
    font-weight: 700;
    display: inline-block;
  }

  .menu-list a:hover {
    color: #276cda;
  }

  .menu-list a.is-active {
    color: white;
    font-weight: 700;
  }

  .tabs ul {
    display: flex;
    flex-flow: row wrap;
  }

  .tabs ul > li {
    display: inline-block;
    flex: 1;
  }

  .modal-card-foot {
    justify-content: flex-end;
  }

  .field.batch-switch {
    display: inline-block;
    float: right;
  }

  .delete-button {
    float: right;
    font-weight: normal;
    padding: 0 1rem;
    height: auto;
  }

</style>

<style>

  .tabs.is-fullwidth li {
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/views/Scoring.vue